<template>
  <div class="dibu">
    <van-tabbar v-if="hasFooter" v-model="active" active-color="#07c160" inactive-color="#000">
      <van-tabbar-item @click="navClick(icon)">
        <span>课程</span>
        <template #icon="props">
          <img :src="props.active ? icon.inactive : icon.active" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="navClick(icon2)">
        <span>公开课</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { Tabbar, TabbarItem, Icon } from "vant";

export default {
  name: "Tabbar",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem, 
    [Icon.name]: Icon,
  },
  data() {
    return {
      hasFooter: true,
      active: JSON.parse(localStorage.getItem("footActive")),
      icon: {
        active: require("@/assect/curriculum.png"),
        inactive: require("@/assect/curriculum2.png"),
        path: "home",
        footActive: 0,
      },
      icon2: {
        active: require("@/assect/open-class-in.png"),
        inactive: require("@/assect/open-class.png"),
        path: "openClass",
        footActive: 1,
      },
    };
  },
  created() {
    if (JSON.parse(localStorage.getItem("footActive")) != null) {
      this.active = JSON.parse(localStorage.getItem("footActive"));
    } else {
      this.active = 0;
    }
  },
  watch: {
    $route(to, from) {
      this.hasFooter = !!to.meta.hasFooter;
    },
  },
  mounted() {
    this.Emit.$on("footNum", this.setActive);
  },
  destroyed() {
    this.Emit.$off("footNum");
  },
  methods: {
    navClick(item) {
      localStorage.setItem("footActive", item.footActive);
      this.$router.push({ name: item.path });
    },
    setActive(num) {
      this.active = num;
    },
  },
};
</script>

<style lang="less" scoped>
.dibu {
  height: 16vw;
  // background-color: red;
  width: 100%;
}
</style>
